import React from 'react';
import PropTypes from 'prop-types';
import { Banner } from '@wds/banner';

const InlineAlertCard = ({ title, description, color }) => (
	<Banner color={color}>
		<Banner.Title>{title}</Banner.Title>
		{description && <Banner.Body>{description}</Banner.Body>}
	</Banner>
);

InlineAlertCard.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string,
	color: PropTypes.oneOf(['note', 'info', 'upgrade', 'success', 'warning', 'error']),
};

InlineAlertCard.defaultProps = {
	description: '',
	color: 'error',
};

export default InlineAlertCard;
